export const GET_PRESENTATIONS = `query Presentations(
  $tenant_id: Int!,
  $filter: FilterPresentationInput,
  $orderBy: PresentationOrderInput,
  $page: Int,
  $limit: Int,
  $searchText: String
) {
  presentations(
    tenant_id: $tenant_id,
    filter: $filter,
    orderBy: $orderBy,
    page: $page,
    limit: $limit,
    searchText: $searchText
  ) {
    __typename
    ... on Presentation {
      id
      tenant_id
      exhibitor_id
      responsible_chair_id
      meeting_id
      group_id
      meeting_date
      suggested_topic_id
      exhibitor_comments
      materials_url
      administrative_status
      invoice_number
      per_diem_amount
      transport_amount
      travel_bonus_amount
      expense_receipts_url
      cancellation_reason
      status_change_comment
      presentation_invoice {
        receipt_file
      }
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
      exhibitor {
        id
        contact {
          id
          firstname
          lastname
          province
        }
      }
      chair {
        id
        contact {
          id
          firstname
          lastname
        }
      }
      topic {
        id
        title
      }
      meeting {
        id
        month
        current_date
        pay
        extra_pay
        expenses
        pay_mode
        exhibitor {
          pay
          pay_virtual
          pay_virtual_short
        }
        group {
          id
          name
          include
          program_variant_id
          program {
            id
            name
            category {
              include
              pro_bono
            }
            province {
              id
              name
              interior
            }
            pricings {
              id
              expenses
              is_active
              valid_to
            }
          }
        }
        meeting_groups {
          id
          group {
            id
            name
          }
        }
      }
    }
    ... on ResultError {
      status_code
      message
    }
  }
}`;

export const GET_PRESENTATION = `query Presentation(
  $tenant_id: Int!,
  $id: Int!
) {
  presentation(
    tenant_id: $tenant_id,
    id: $id
  ) {
    __typename
    ... on Presentation {
      id
      tenant_id
      exhibitor_id
      responsible_chair_id
      meeting_id
      group_id
      meeting_date
      suggested_topic_id
      exhibitor_comments
      materials_url
      administrative_status
      invoice_number
      per_diem_amount
      transport_amount
      travel_bonus_amount
      expense_receipts_url
      cancellation_reason
      status_change_comment
      presentation_invoice {
        receipt_file
      }
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
      exhibitor {
        id
        contact {
          id
          firstname
          lastname
          province
        }
      }
      chair {
        id
        contact {
          id
          firstname
          lastname
        }
      }
      topic {
        id
        title
      }
      meeting {
        id
        month
        current_date
        pay
        extra_pay
        expenses
        pay_mode
        exhibitor {
          pay
          pay_virtual
          pay_virtual_short
        }
        group {
          id
          name
          include
          program_variant_id
          program {
            id
            name
            category {
              include
              pro_bono
            }
            province {
              id
              name
              interior
            }
            pricings {
              id
              expenses
              is_active
              valid_to
            }
          }
        }
        meeting_groups {
          id
          group {
            id
            name
          }
        }
      }
    }
    ... on ResultError {
      status_code
      message
    }
  }
}`;


export const PRESENTATION_FILE_DOWNLOAD_URL = `query PresentationFileDownloadUrl(
  $tenant_id: Int!,
  $id: Int!,
  $type: String!
) {
  presentationFileDownloadUrl(
    tenant_id: $tenant_id,
    id: $id,
    type: $type
  )
}`;

export const PRESENTATIONS_COUNT = `
  query presentationsCount(
    $tenant_id: Int!
    $filter: FilterPresentationInput
    $searchText: String
  ) {
    presentationsCount(
      tenant_id: $tenant_id
      filter: $filter
      searchText: $searchText
    ) {
      __typename
      ... on Count {
        count
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
